import ol = require("ol");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

class Snapshot {

    static render(canvas: HTMLCanvasElement, feature: ol.Feature) {
        feature = feature.clone();
        let geom = feature.getGeometry();
        let extent = geom.getExtent();

        let [dx, dy] = ol.extent.getCenter(extent);
        let scale = Math.min(canvas.width / ol.extent.getWidth(extent), canvas.height / ol.extent.getHeight(extent));

        geom.translate(-dx, -dy);
        geom.scale(scale, -scale);
        geom.translate(canvas.width / 2, canvas.height / 2);

        let vtx = ol.render.toContext(canvas.getContext("2d"));
        let styles = feature.getStyleFunction()(0);
        if (!Array.isArray(styles)) styles = <any>[styles];
        vtx.drawFeature(feature, styles[0]);
    }

    /**
     * convert features into data:image/png;base64;  
     */
    static snapshot(feature: ol.Feature) {
        let canvas = document.createElement("canvas");
        let geom = feature.getGeometry();
        this.render(canvas, feature);
        return canvas.toDataURL();
    }
}

class Command extends Base<any> {

    static about = "renders a feature as an images";

    static input = {
        "activeFeature": "the feature to snapshot"
    };

    static output = {
        "snapshot": "the snapshot as image data"
    };

    execute(args: any = this.args) {
        let feature = <ol.Feature>Utils.extend(this.findOption("activeFeature")).olFeature;
        if (feature) {
            this.trigger({
                snapshot: Snapshot.snapshot(feature)
            });
        }
    }

}

export = Command; 